/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuIcon from './ic_menu_white_24dp_2x.png';
import BackIcon from './ic_arrow_back_white_24dp_2x.png';
import SettingsIcon from './baseline_settings_white_24dp.png';
import BusinessReportIcon from './baseline_insert_chart_white_24dp.png';
import './Actionbar.css';

/**
 * Represents the actionbar component that apperars on the top of the screen.
 */

export default class Actionbar extends Component {
   
    /**
     * Properties.
     */

    static propTypes = {
        context:            PropTypes.object.isRequired,        
        appname:            PropTypes.string,
        menuvisible:        PropTypes.bool.isRequired,
        onToggleMenu:       PropTypes.func.isRequired,
        onBack:             PropTypes.func.isRequired,
        rightIcon:          PropTypes.object,
        showBack:           PropTypes.bool.isRequired,
        onRightIconTouched: PropTypes.func.isRequired,
        onSettings:         PropTypes.func.isRequired,
        onBusinessReport:   PropTypes.func.isRequired
    }

    /**
     * Event that fires when the user touches the left icon.
     */

    _onLeftIconTouched = () => {
        if (this.props.showBack) {
            this.props.onBack();
        } else {

            // Toggling the menu

            this.props.onToggleMenu();
        }
    }

    _showHelp = () => {
        window.open('https://drive.google.com/open?id=1myE5Hs3rPDlpMpnRa0fAFE6zWoyMjj3PwQVf3u-KJdY');
    }

    /** 
     * Actionbar renderer.
     */

    render() {
        return (
            <div className="actionbar">
                <div className="actionbar-container horizontal center">

                    {/* Home icon */}

                    <div className="actionbar-iconcontainer" title={this.props.menuvisible ? 'Menü bezárása' : 'Menü'} onClick={this._onLeftIconTouched}>
                        <img alt="Back icon" src={BackIcon} className="actionbar-home actionbar-back-icon" style={{ opacity: (this.props.showBack || this.props.menuvisible ? 1 : 0) }} />
                        <img alt="Home icon" src={MenuIcon} className="actionbar-home actionbar-menu-icon" style={{ opacity: (this.props.showBack || this.props.menuvisible ? 0 : 1) }} />
                    </div>

                    {/* Application name */}

                    <div className="actionbar-appname">{this.props.appname}</div>
                    <div className="flex"></div>

                    {/* Help */}

                    <div className="actionbar-help" onClick={this._showHelp}>{this.props.context.locale.help.label}</div>

                    {/* Business report */}

                    <img alt="Business report" src={BusinessReportIcon} title={this.props.context.locale.businessreport.name} className="actionbar-righticon" onClick={this.props.onBusinessReport}/>

                    {/* Settings */}

                    <img alt="Settings" src={SettingsIcon} title={this.props.context.locale.menu.settings} className="actionbar-righticon" onClick={this.props.onSettings}/>

                    {/* Icon on the right side */}

                    { this.props.rightIcon && <img alt="Icon" src={typeof(this.props.rightIcon) === 'string' ? this.props.rightIcon : this.props.rightIcon.icon} title={typeof(this.props.rightIcon) === 'string' ? null : this.props.rightIcon.tooltip} className="actionbar-righticon" onClick={this.props.onRightIconTouched}/> }
                </div>

                {/* Shadow */}
                
                <div className="actionbar-shadow"></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Actionbar/Actionbar.js